import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { accessLocalStorage, exportSelectAllTrunksWithInterconnection, exportDeleteTrunks, fetchEndpoints} from '../../../services';

import PbxContext from '../../../context/PbxContext';
import '../../../libs/bulma.min.css';
import './TrunksList.css';

import Loading from '../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileContract, faTrash, faEdit, faPhoneSquareAlt, faCircle, faExchangeAlt, faArrowsAltH, faArrowRight, faPhone, faPlus, faEye } from '@fortawesome/free-solid-svg-icons';

function EndpointsList() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsChangeFormElements, toggleIsHidden, setItemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [phones, setPhones] = useState(() => []);
  const [trunksSelected, setTrunksSelected] = useState('');
  const [disable, setDisable] = useState(true);
  const [filterText, setFilterText] = useState('');

  const history = useHistory();

  const getTrunks = async () => {
    try {
      const trunksList = await exportSelectAllTrunksWithInterconnection();
      
      // Se a nova função falhar, usar a função tradicional
      let finalTrunksList = trunksList;
      
      // Verificar se é um array válido
      if (!Array.isArray(trunksList)) {
        console.warn('Função com interconexão falhou, usando função tradicional');
        const { exportSelectAllTrunks } = await import('../../../services');
        finalTrunksList = await exportSelectAllTrunks();
      }
      
      if (!Array.isArray(finalTrunksList)) {
        console.error('Resposta da API não é um array:', finalTrunksList);
        setLoading(false);
        return [];
      }

      const endpointsAstFetched = await fetchEndpoints();
      
      const trunksStatusAst = Array.isArray(endpointsAstFetched) ? endpointsAstFetched.reduce((acc, trunk) => {
        if (isNaN(trunk.resource)) {
          acc[trunk.resource] = trunk.state;
        }
        return acc;
      }, {}) : {};

      const trunksStatus = finalTrunksList.map((trunk) => { 
        return { 
          ...trunk, 
          state: trunksStatusAst[trunk.name] || 'offline' 
        } 
      });

      setLoading(false);
      return trunksStatus;
    } catch (error) {
      console.error('Erro ao buscar trunks:', error);
      setLoading(false);
      return [];
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    let trunksFetched = await getTrunks();
    
    // Garantir que trunksFetched é um array
    if (!Array.isArray(trunksFetched)) {
      trunksFetched = [];
    }
    
    // Filtrar por tenant se não for vgs
    trunksFetched = idtenant.includes('vgs') ? trunksFetched : trunksFetched.filter((trunk) => trunk && idtenant.includes(trunk.tenant));
    setPhones(trunksFetched);
    return trunksFetched;
  }, []);

  const handleChangeSelectedTrunks = (element) => {
    // setTrunksSelected((prevState) => {
    //   const onlineState = prevState.includes(element) ? [...prevState.filter((e) => e !== element)] : [...prevState, element];
    //   onlineState.length > 0 ? setDisable(false) : setDisable(true);
    //   return onlineState;
    // });
    // element.length > 0 ? setDisable(false) : setDisable(true);
    setTrunksSelected(element)
    element.length > 0 ? setDisable(false) : setDisable(true);
  };

  const handleClickDelete = async () => {
    // console.log(trunksSelected);
    const sendDeleteTrunks = await exportDeleteTrunks([trunksSelected]);
    if(sendDeleteTrunks.length === undefined) {
      toggleIsHidden('#alert-confirm-trunks-delete');
      return toggleIsChangeFormElements('alert-trunks-not-delete', 'column is-half is-offset-one-quarter message is-danger is-active');
    };
    toggleIsHidden('#alert-confirm-trunks-delete');
    setDisable(true);
    toggleIsHidden('#buttons');

    validateUserLogged();
    return;
  };

  const handleClickUpdate = async () => {
    setItemsSelectedToEdit([trunksSelected]);
    return history.push('/config/tronco/id');
  };

  const handleClickEdit = () => {
    if (!trunksSelected || trunksSelected.length === 0) {
      return;
    }
    setItemsSelectedToEdit([trunksSelected]);
    setTimeout(() => {
      history.push('/config/tronco/editar');
    }, 100);
  };

  const filteredPhones = phones.filter((phone) => {
    const searchText = filterText.toLowerCase();
    return (
      phone.name.toLowerCase().includes(searchText) ||
      (phone.trunk && phone.trunk.toLowerCase().includes(searchText)) ||
      (phone.serverIP && phone.serverIP.toLowerCase().includes(searchText)) ||
      (phone.codec && phone.codec.toLowerCase().includes(searchText)) ||
      (phone.tenant && phone.tenant.toLowerCase().includes(searchText)) ||
      (phone.real_number && phone.real_number.toLowerCase().includes(searchText))
    );
  });

  useEffect(() => {
    let cancel = false;
    
    if (cancel) return;
    validateUserLogged();

    return () => {
      cancel = true
    };
  }, [validateUserLogged]);

  return (
    <div className="trunks-list-container">
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="trunks-list-header">
            <div className="trunks-list-title-wrapper">
              <svg className="trunks-list-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <div>
                <h1 className="trunks-list-title">Lista de Troncos</h1>
                <p className="trunks-list-subtitle">Gerencie os troncos SIP do sistema ({phones.length} troncos)</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-trunks-not-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-trunks-not-delete')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível deletar os troncos selecionados.
              </div>
            </div>

            <div id="alert-confirm-trunks-delete" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-confirm-trunks-delete')}>×</button>
              </div>
              <div className="alert-body">
                Tem certeza que quer deletar o(s) tronco(s) selecionado(s)?
              </div>
              <div className="alert-actions" style={{display: 'flex', justifyContent: 'center', gap: '1rem', padding: '1rem', borderTop: '1px solid #ecf0f1'}}>
                <button className="btn-alert btn-alert-confirm" type="submit" onClick={() => handleClickDelete()}>
                  <FontAwesomeIcon icon={faTrash} />
                  <span>Confirmar</span>
                </button>
                <button className="btn-alert btn-alert-cancel" type="submit" onClick={() => {
                  toggleIsHidden('#alert-confirm-trunks-delete');
                  toggleIsHidden('#buttons');
                }}>
                  <span>Cancelar</span>
                </button>
              </div>
            </div>
          </div>

          <div className="filter-section">
            <div className="filter-input-wrapper">
              <svg className="filter-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <input
                type="text"
                className="filter-input"
                placeholder="Filtrar por nome, número, servidor IP, codec, tenant ou número real..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
              {filterText && (
                <button className="filter-clear" onClick={() => setFilterText('')}>
                  ×
                </button>
              )}
            </div>
            <div className="filter-results">
              Exibindo {filteredPhones.length} de {phones.length} tronco(s)
            </div>
          </div>

          <div className="trunks-table-wrapper">
            <table className="trunks-table">
              <thead className="trunks-table-header">
                <tr>
                  <th>Sel.</th>
                  <th>Status</th>
                  <th>Nome</th>
                  <th>Número</th>
                  <th>Servidor IP</th>
                  <th>Codec</th>
                  <th>Tenant</th>
                  <th>Modo</th>
                  <th>Número Real</th>
                </tr>
              </thead>
              <tbody>
                {filteredPhones.map((phone) => {
                  const stateColor = phone.state === 'online' ? 'status-online' : 'status-offline';
                  const hasRealNumber = phone.real_number && phone.real_number.trim() !== '';
                  const isUnidirectional = phone.mode === 'unidirecional';
                  const trunkMode = isUnidirectional ? 'Unidirecional' : 'Bidirecional';

                  return (
                    <tr key={phone.name + phone.state}>
                      <td>
                        <input 
                          className="trunk-checkbox"
                          name="trunksSelectForEdit" 
                          type="radio" 
                          value={phone.name} 
                          onChange={(e) => handleChangeSelectedTrunks(e.target.value)} 
                        />
                      </td>
                      <td>
                        <span className={`trunk-status ${stateColor}`}>
                          <FontAwesomeIcon icon={faCircle} />
                        </span>
                      </td>
                      <td>
                        <span className="trunk-name">{phone.name}</span>
                      </td>
                      <td>
                        <span className="trunk-badge badge-number">{phone.trunk || 'N/A'}</span>
                      </td>
                      <td>
                        <span className="trunk-ip">{phone.serverIP || 'N/A'}</span>
                      </td>
                      <td>
                        <span className="trunk-badge badge-codec">{phone.codec || 'N/A'}</span>
                      </td>
                      <td>
                        <span className="trunk-badge badge-tenant">{phone.tenant || 'N/A'}</span>
                      </td>
                      <td>
                        <span className={`trunk-badge ${isUnidirectional ? 'badge-mode-uni' : 'badge-mode'}`}>
                          <FontAwesomeIcon icon={isUnidirectional ? faArrowRight : faArrowsAltH} />
                          <span style={{marginLeft: '0.25rem'}}>{trunkMode}</span>
                        </span>
                      </td>
                      <td>
                        {hasRealNumber ? (
                          <span className="trunk-badge badge-real-number">
                            <FontAwesomeIcon icon={faExchangeAlt} />
                            <span style={{marginLeft: '0.25rem'}}>{phone.real_number}</span>
                          </span>
                        ) : (
                          <span style={{color: '#bdc3c7'}}>—</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div id="buttons" className="trunks-actions">
            <button className="btn-trunk-action btn-new-trunk" onClick={() => history.push('/config/tronco/adicionar')}>
              <FontAwesomeIcon icon={faPlus} />
              <span>Adicionar Novo</span>
            </button>
            <button 
              className="btn-trunk-action btn-view-trunk" 
              onClick={() => handleClickUpdate()} 
              disabled={disable}
            >
              <FontAwesomeIcon icon={faEye} />
              <span>Consultar</span>
            </button>
            <button 
              className="btn-trunk-action btn-edit-trunk" 
              onClick={() => handleClickEdit()} 
              disabled={disable}
            >
              <FontAwesomeIcon icon={faEdit} />
              <span>Editar</span>
            </button>
            <button
              className="btn-trunk-action btn-delete-trunk"
              onClick={() => {
                toggleIsHidden('#alert-confirm-trunks-delete');
                toggleIsHidden('#buttons');
              }}
              disabled={disable}
            >
              <FontAwesomeIcon icon={faTrash} />
              <span>Deletar</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default EndpointsList;
